<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
$(document).on("change", ".card-flavour-wrap select", function() {

    var selectedValue = $(this).val();
    var selectedImage = $(this).find('option:selected').attr('data-image');
    var selectedVID = $(this).find('option:selected').data('variant');
    var selectedTitle = $(this).find('option:selected').data('title');
  $(this).parents(".card").find("input[name=id]").val(selectedVID);

    $(this).parents(".card").find(".card-title span").html(selectedTitle);
    $(this).parents(".card").find(".card-media img").attr("src", selectedImage);
    $(this).parents(".card").find(".card-media img").attr("srcset", selectedImage);
});

 $(document).ready(function() {
   if($(window).width() <= 480){
      $( ".megamenu_video video" ).remove();
   }
   $('[data-fraudulent]').trigger('change');
});


// $(document).on("change", ".product-details .quantity_selector input[name=quantity]", function() {
//     var qty = $(this).val();
//   // var priceText = $(".productView-price .price-item").text(); 
//   var priceText = $(".productView-price [data-price]").attr("data-price"); 
// var price = parseFloat(priceText.replace(/[^0-9.]/g, ''));
// var total = parseFloat(qty * price);
//   // console.log("$"+total.toFixed(2));
//   $(".productView-price .price-item").text("$"+total.toFixed(2));
// });




    $(document).on('change','[data-fraudulent]', function() {
        // Check if the checkbox is checked
        var inputValue = $(this).is(':checked') ? 'true' : 'false';
        console.log("Checkbox changed, value: " + inputValue); // Debugging

        // Prepare the data for the cart attributes
        var attributes = {
            'Authority to Leave': inputValue
        };

        // Send AJAX request to update the cart attributes
        $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: {
                attributes: attributes
            },
            dataType: 'json',
            success: function(cart) {
                console.log('Cart attribute updated successfully:', cart);
            },
            error: function(error) {
                console.error('Error updating cart attribute:', error);
            }
        });
    });
